import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Privacy() {
  return (
    <div className="relative">
      <Navbar forceLight />
      <main className="bg-white">
        {/* Hero */}
        <section className="relative bg-[#f8f6f3] py-20 md:py-28">
          <div className="px-6 md:px-10 lg:px-16 max-w-5xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-[#1a1a1a] mb-4">
              Política de Privacidad
            </h1>
            <p className="text-sm md:text-base text-gray-500 max-w-2xl mx-auto leading-relaxed">
              En Esencia&co. valoramos y respetamos tu privacidad. A continuación te explicamos cómo recopilamos, usamos y protegemos tu información personal.
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 md:py-24">
          <div className="px-6 md:px-10 lg:px-16 max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  1. Responsable del Tratamiento
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  El responsable del tratamiento de los datos personales recogidos a través de este sitio web es Esencia&co., con domicilio social en Bogotá, Colombia, Av. de las Américas # 62-11. Puedes contactarnos en comercial@esenciayco.co o al teléfono +57 311 2245754 para cualquier consulta relacionada con la protección de datos.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  2. Información que Recopilamos
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                  Recopilamos información personal que nos proporcionas directamente cuando:
                </p>
                <ul className="list-disc pl-6 text-sm md:text-base text-gray-600 leading-relaxed space-y-2">
                  <li>Completas formularios de contacto o solicitud de información</li>
                  <li>Te registras para recibir nuestro boletín informativo</li>
                  <li>Solicitas cotizaciones de nuestros productos de perfumería</li>
                  <li>Participas en encuestas o promociones</li>
                  <li>Nos contactas por teléfono, correo electrónico o WhatsApp</li>
                </ul>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mt-4">
                  La información puede incluir: nombre completo, dirección de correo electrónico, número de teléfono, nombre de empresa, dirección fiscal, información de pedidos y preferencias de productos.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  3. Finalidad del Tratamiento
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                  Utilizamos tu información personal para las siguientes finalidades:
                </p>
                <ul className="list-disc pl-6 text-sm md:text-base text-gray-600 leading-relaxed space-y-2">
                  <li>Gestionar y responder a tus solicitudes de información</li>
                  <li>Procesar pedidos y envíos de insumos de perfumería</li>
                  <li>Enviar comunicaciones comerciales sobre productos y servicios</li>
                  <li>Mejorar la experiencia de usuario en nuestro sitio web</li>
                  <li>Cumplir con obligaciones legales y contractuales</li>
                  <li>Realizar análisis estadísticos y de mercado</li>
                </ul>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  4. Base Legal
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  El tratamiento de tus datos se basa en tu consentimiento explícito, la ejecución de un contrato o una relación precontractual, el cumplimiento de obligaciones legales aplicables, o nuestro interés legítimo en mantener una comunicación comercial adecuada con clientes y potenciales clientes del sector de perfumería.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  5. Conservación de los Datos
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Conservaremos tus datos personales durante el tiempo necesario para cumplir con la finalidad para la que fueron recopilados y para determinar las posibles responsabilidades que pudieran derivarse de dicha finalidad y del tratamiento de los datos. En el caso de suscriptores a comunicaciones comerciales, mantendremos tus datos hasta que solicites su supresión.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  6. Derechos del Usuario
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                  Como titular de los datos, tienes derecho a:
                </p>
                <ul className="list-disc pl-6 text-sm md:text-base text-gray-600 leading-relaxed space-y-2">
                  <li>Acceder a tus datos personales</li>
                  <li>Solicitar la rectificación de datos inexactos</li>
                  <li>Solicitar la supresión de tus datos cuando ya no sean necesarios</li>
                  <li>Solicitar la limitación del tratamiento de tus datos</li>
                  <li>Oponerte al tratamiento de tus datos</li>
                  <li>Solicitar la portabilidad de tus datos</li>
                </ul>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mt-4">
                  Puedes ejercer estos derechos enviando una solicitud a comercial@esenciayco.co incluyendo una copia de tu documento de identidad.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  7. Seguridad de la Información
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Implementamos medidas técnicas y organizativas apropiadas para proteger tus datos personales contra accesos no autorizados, pérdida, alteración o destrucción. Utilizamos conexiones seguras (HTTPS), almacenamiento en servidores protegidos y controles de acceso estrictos.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  8. Cesión a Terceros
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  No vendemos, alquilamos ni compartimos tu información personal con terceros con fines comerciales sin tu consentimiento explícito. Podemos compartir información con proveedores de servicios que nos ayudan a operar nuestro negocio (como servicios de hosting, envío de correos o transporte de mercancía), siempre bajo acuerdos de confidencialidad y solo para las finalidades descritas.
                </p>
              </div>

              <div className="mb-12">
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  9. Modificaciones
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Nos reservamos el derecho a modificar esta política de privacidad en cualquier momento para adaptarla a novedades legislativas o cambios en nuestros procedimientos. Te recomendamos revisar esta página periódicamente para estar informado sobre cómo protegemos tu información.
                </p>
              </div>

              <div>
                <h2 className="text-xl md:text-2xl font-medium text-[#1a1a1a] mb-4">
                  10. Contacto
                </h2>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  Si tienes preguntas, comentarios o inquietudes sobre esta política de privacidad o el tratamiento de tus datos personales, no dudes en contactarnos a través de comercial@esenciayco.co o llamando al +57 311 2245754.
                </p>
              </div>
            </div>

            <div className="mt-16 pt-8 border-t border-gray-200">
              <p className="text-xs text-gray-400 text-center">
                Última actualización: mayo 2026
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}